import { Dialog } from "primereact/dialog";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

export const Confirmation = (props) => {
    const { t } = useTranslation("common");

    const footer = (
        <>
            <Button label={t("no")} icon="pi pi-times" className="p-button-text" onClick={props.hideAction} />
            <Button label={t("yes")} icon="pi pi-check" onClick={props.processAction} />
        </>
    );

    return (
        <Dialog visible={props.visible} style={{ width: "25%" }} header={t("confirm")} modal footer={footer} onHide={props.hideAction}>
            <div className="flex align-items-center justify-content-center" style={{ maxWidth: "max-content" }}>
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem" }} />
                {props.confirmMessage}
            </div>
        </Dialog>
    );
};
